import React from 'react'

export const loadScripts = () => {
	const scriptA = document.createElement('script')
	scriptA.src = '/assets/js/pages/dashboard.init.js'
	// scriptA.async = true
	scriptA.id = 'scriptA'
	document.body.appendChild(scriptA)
}

export const removeScripts = () => {
	// remove existing
	document.getElementById('scriptA').remove()
}
